import Loader from '@/components/Loader'
import { cva } from 'class-variance-authority'

const loadingVariants = cva('grid h-dvh place-items-center', {
  variants: {
    fixed: {
      true: 'fixed inset-0 pointer-events-auto z-[10000]',
    },
  },
})

type LoadingProps = {
  fixed?: boolean
  className?: string
}

export default function Loading({ fixed = true, className }: LoadingProps) {
  const loadingClasses = loadingVariants({ fixed, className })

  return (
    <div
      className={loadingClasses}
      style={{
        background: 'rgba(0, 0, 0, 0.3)',
      }}
    >
      <Loader />
    </div>
  )
}
